import { create } from 'zustand'

const useTaskProcessingStore = create((set, get) => ({
    // État de traitement par machine : { machineId: { pending: 0, received: 0 } }
    machineProcessing: {},
    
    // Initialiser ou incrémenter le compteur de tâches en attente
    addPendingTasks: (machineId, count) => set((state) => {
        const current = state.machineProcessing[machineId] || { pending: 0, received: 0 };
        return {
            machineProcessing: {
                ...state.machineProcessing,
                [machineId]: {
                    ...current,
                    pending: current.pending + count
                }
            }
        };
    }),
    
    // Quand des tâches sont reçues (apparaissent dans la liste)
    tasksReceived: (machineId, count) => set((state) => {
        const current = state.machineProcessing[machineId] || { pending: 0, received: 0 };
        const newPending = Math.max(0, current.pending - count);
        const newReceived = current.received + count;
        
        // Si plus de tâches en attente, on peut nettoyer
        if (newPending === 0) {
            const { [machineId]: _, ...rest } = state.machineProcessing;
            return { machineProcessing: rest };
        }
        
        return {
            machineProcessing: {
                ...state.machineProcessing,
                [machineId]: {
                    pending: newPending,
                    received: newReceived
                }
            }
        };
    }),
    
    // Obtenir l'état de traitement d'une machine
    getMachineProcessing: (machineId) => {
        const state = get();
        return state.machineProcessing[machineId] || { pending: 0, received: 0 };
    },
    
    // Vérifier si une machine est en cours de traitement
    isProcessing: (machineId) => {
        const state = get();
        const processing = state.machineProcessing[machineId];
        return processing && processing.pending > 0;
    },
    
    // Réinitialiser le compteur d'une machine
    clearMachineProcessing: (machineId) => set((state) => {
        const { [machineId]: _, ...rest } = state.machineProcessing;
        return { machineProcessing: rest };
    })
}))

export default useTaskProcessingStore